import React, { useState } from "react";
import './CustomLoader.scss';

export default function CustomLoader({activeLoader}) {


return(

  <div className={`customLoader ${activeLoader}`}>

      <div className="customLoaderContent fadeInUp">

        <img src={require("../../assets/imgs/redirect.svg")} alt="" className="redirect" />

        <h2>Hang Tight!</h2>

        <p>You're being redirected to another page, Click <span>"ACCEPT"</span> on the next page to access content.</p>

      </div>
    

  </div>

)

  
}

